import isEqual from 'react-fast-compare';
import {useSelector} from 'react-redux';

export default function useStore(store: string) {
    return useSelector((data) => data[store], isEqual);
}
